module.exports = __webpack_public_path__ + "img/photo_archive.39eb48af.png";